import ModalFooterDefault from 'src/components/Modal/partials/ModalFooter/ModalFooterDefault.component';
import { ModalHeader } from 'src/components/Modal/partials/ModalHeader/ModalHeader.component';
import withConnectedModal from 'src/components/Modal/WithConnectedModal';
import RemodulationRequestsModalBody from './RemodulationRequestsModalBody.component';

export default withConnectedModal({
  showOnMount: true,
  hideOnUnmount: true,
  modalName: 'SortModal',
  headerComponent: ModalHeader,
  bodyComponent: RemodulationRequestsModalBody,
  footerComponent: ModalFooterDefault,
});
